import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import MainBody from "../../../components/MainBody/MainBody";
import MainTabList from "../../../components/MainBody/MainTabList";
import Trainings from "./Trainings/Trainings";
import Policies from "./Policies/Policies";
import RiskAssessmentTabs from "./RiskAssessmentTabs";

const tabsKey = [
  {
    name: "Risk Assessment",
    tabName: "risk-assessment",
    value: 1,
  },
  {
    name: "Policies",
    tabName: "policies",
    value: 2,
  },
  {
    name: "Trainings",
    tabName: "trainings",
    value: 3,
  },
];

const AdminAMLCTFTabs = () => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const selectedTab = query.get("tab") || "risk-assessment";
  const defaultActiveKey = tabsKey?.find(
    (item) => item?.tabName === selectedTab,
  )?.value;

  const [activeTab, setActiveTab] = useState(defaultActiveKey);
  const navigate = useNavigate();

  useEffect(() => {
    navigate(
      `/admin/aml-ctf?tab=${
        tabsKey?.find((item) => item?.value === activeTab)?.tabName
      }`,
      {
        replace: true,
      },
    );
  }, [activeTab, navigate]);

  useEffect(() => {
    setActiveTab(tabsKey?.find((item) => item?.tabName === selectedTab)?.value);
  }, [selectedTab]);

  return (
    <>
      <MainBody
        search={false}
        loading={false}
        mainClassName="w-[calc(100%-3rem)]"
        mainTitle={"AML/CTF"}
      >
        <MainTabList
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          tabsKey={tabsKey}
          className={`bg-background relative max-h-[80vh] overflow-y-auto`}
        >
          {activeTab === 1 ? (
            <RiskAssessmentTabs />
          ) : activeTab === 2 ? (
            <Policies />
          ) : activeTab === 3 ? (
            <Trainings />
          ) : (
            ""
          )}
        </MainTabList>
      </MainBody>
    </>
  );
};

export default AdminAMLCTFTabs;
